import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chairman-message',
  templateUrl: './chairman-message.component.html',
  styleUrls: ['./chairman-message.component.scss']
})
export class ChairmanMessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
